/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgMarsDouble = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M22 10v6h-2v-2.586l-2.553 2.555c.32.541.515 1.165.548 1.831L18 18a4 4 0 1 1-1.968-3.446L18.585 12H16v-2zm-8 6a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm0-14v6h-2V5.414L9.447 7.969c.32.541.515 1.165.548 1.831L10 10a4 4 0 1 1-1.968-3.446L10.585 4H8V2zM6 8a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgMarsDouble as MarsDouble };
